import { Stack, Typography } from '@mui/material';
import SwitchButton from '~/components/common/SwitchButton';
import { IBillingFrequency } from '~/models/plan';
import themes from '~/themes';

type ChangeBilledProps = {
  onChange?: (e: any) => void;
  billingFrequency?: IBillingFrequency;
  isShowHighlight?: boolean;
};

export const ChangeBilled: React.FC<ChangeBilledProps> = ({
  onChange,
  billingFrequency,
  isShowHighlight = false,
}) => (
  <Stack
    direction='row'
    justifyContent='center'
    spacing={1}
    alignItems='center'
    color={themes.color.violet500}
  >
    <Typography>Billed monthly</Typography>
    <SwitchButton
      checked={billingFrequency === IBillingFrequency.Year}
      noText
      onChange={onChange}
      sx={{
        '& .Mui-checked + .MuiSwitch-track, .MuiSwitch-track': {
          backgroundColor: '#edf0f7 !important',
        },
        '& .MuiSwitch-thumb': {
          backgroundColor: '#ed6808 !important',
        },
      }}
    />
    <Typography sx={{ marginLeft: '0px !important' }}>
      Billed annually
    </Typography>
    <Typography
      padding={0.5}
      sx={{
        borderRadius: '5px',
        minWidth: 50,
        marginLeft: '0 !important',
        ...(isShowHighlight && {
          marginLeft: '10px !important',
          background: themes.bg.darkPurple,
          color: themes.color.white,
          fontSize: '12px',
        }),
      }}
    >
      {isShowHighlight ? '20% OFF' : '(20% off)'}
    </Typography>
  </Stack>
);
